(angular => {

  angular.module("EventChecklist", [
      "Config"
    ])

    .config(["$routeProvider", configRouter]);

  function configRouter($routeProvider) {
    $routeProvider
      .when("/checklist", {
        controller: "EventChecklist.ListCtrl",
        controllerAs: "$ctrl",
        templateUrl: `admin/eventChecklist/list/list.html`,
        role: ['admin', 'user', 'company_manager', 'organizer', 'stand_builder', 'coordinator']
      });
  }

})(angular);
